import { Theme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";

const styles = {
    autocompleteSearchPerson: makeStyles((theme: Theme) =>
        createStyles({
            autoCompleteSearchRoot: {
                marginBottom: theme.spacing(1.2),
                "& .MuiInputBase-root": {
                    paddingRight: 0,
                },
            },
            optionContainer: {
                padding: theme.spacing(0.1),
                "& p": {
                    padding: 0,
                    margin: 0,
                    fontWeight: "bold",
                },
            },
            optionNameLabel: {
                textTransform: "capitalize",
            },
            optionCurrentWorkInfo: {
                fontSize: 12,
            },
            cardDivider: {
                width: "1px",
                height: "40px",
                backgroundColor: theme.palette.others.teal,
                marginTop: "auto",
                marginBottom: "auto",
            },
        })
    ),
};

export default styles;
